import { cn } from '@kit/ui/utils';

interface FormSectionBannerProps {
  /**
   * Contextual message that explains why this information is being collected.
   */
  message: string;
  /**
   * Optional additional CSS classes.
   */
  className?: string;
}

/**
 * Quiet inline section intro for wizard form sections.
 *
 * Renders as a single muted paragraph — no box, no border, no icon, no colored
 * background. The "info banner" pattern (blue box with an info icon) is banned
 * by the Flow design brief: helper text whispers inline, it never sits in a
 * colored container. See `.impeccable.md` (Principle 3) and the
 * `flow-brand-tokens` clause for the rationale.
 *
 * The component preserves its existing API (`message` prop) so all current
 * callsites in the dancer profile setup wizard, contract details wizard,
 * location step, and media upload step keep working — they just look right.
 */
export function FormSectionBanner({
  message,
  className,
}: FormSectionBannerProps) {
  return (
    <p
      className={cn(
        'text-muted-foreground max-w-[60ch] text-sm leading-relaxed',
        className,
      )}
    >
      {message}
    </p>
  );
}
